import { Typography } from "@mui/material";
import { OverflowText } from "@verity/components/core";
import { OrderingAnswer, OrderingOptionInstructor } from "@verity/api-client/types";
import pageStyles from "../QuizResultPanel.module.css";
import styles from "./QuestionAnswer.module.css";
import { AnswerStatusChip, AnswerViewProps, CorrectAnswerViewProps, t } from "./shared";

export function OrderingAnswerView({ question, response }: AnswerViewProps) {
	const options = (question.options as OrderingOptionInstructor[]) ?? [];
	const userAnswers: OrderingAnswer = (response?.answer as OrderingAnswer) ?? [];

	if (response?.isAnswered !== true || userAnswers.length === 0) {
		return <AnswerStatusChip userText="" isCorrect={null} style={{ margin: "0" }} />;
	}

	return (
		<div className={styles.optionList}>
			{userAnswers.map((opt, idx) => {
				const option = options.find((o) => o.id === opt);
				if (!option) return null;
				const isCorrect = option.order === idx + 1;
				return (
					<div key={idx} className={`${styles.option} ${isCorrect ? styles.correct : styles.incorrect}`}>
						<div className={`${styles.optionIndexBox} ${isCorrect ? styles.correct : styles.incorrect}`}>{idx + 1}</div>

						<OverflowText
							variant="body2"
							fontWeight={400}
							fontSize="14px"
							style={{
								flexGrow: 1,
								minWidth: 0,
							}}
						>
							{option.text}
						</OverflowText>
					</div>
				);
			})}
		</div>
	);
}

export function OrderingCorrectAnswer({ question }: CorrectAnswerViewProps) {
	const options = (question.options as OrderingOptionInstructor[]) ?? [];
	if (options.length === 0) return null;
	const sorted = [...options].sort((a, b) => a.order - b.order);
	return (
		<div className={styles.correctAnswerSection}>
			<Typography className={pageStyles.sectionLabel}>{t("correctAnswer")}</Typography>
			<div className={styles.optionList}>
				{sorted.map((option, idx) => (
					<div key={idx} className={styles.option}>
						<div className={styles.optionIndexBox}>{idx + 1}</div>

						<OverflowText
							variant="body2"
							fontWeight={400}
							fontSize="14px"
							style={{
								flexGrow: 1,
								minWidth: 0,
							}}
						>
							{option.text}
						</OverflowText>
					</div>
				))}
			</div>
		</div>
	);
}
